// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastPlayer-cls1_53Q","cls2":"PodcastPlayer-cls2_Zn6 PodcastPlayer-cls1_53Q"};